import React, { useContext, useEffect, useReducer, useMemo } from 'react'

import { Box, IconButton, Tooltip } from '@mui/material'
import { api } from '../../../services/api';
import toast from 'react-hot-toast'
import { getSession } from '../../../contexts/auth';
import { lockedReducer } from '../../Utils/reducers';
import { SmartToy } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import EditFunctionLogsModal from './Edit-functionlogs-model';
import MemoryIcon from '@mui/icons-material/Memory';
import Table, { TableHook } from '../../Table';
import { ResponsiveActionBox } from '../../Table/mobileTable';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import dayjs from 'dayjs';
import { PlayCircleFilledWhite, OpenInBrowser, HourglassBottom, Notes, Send, AdsClick, Message, WebAssetOff, StopCircle, Error, PlaylistAdd, MiscellaneousServices } from '@mui/icons-material';

const url = '/function_log/'

export const avatars = {
    'init': (<PlayCircleFilledWhite />),
    'run': (<SmartToy />),
    //'sleep': (<AccessTimeIcon />),
    'subscript': (<MemoryIcon />),
    'setvar': (<MiscellaneousServices />),
    'getvar': (<MiscellaneousServices />),
    'get_link': (<OpenInBrowser />),
    'sleep': (<HourglassBottom />),
    'send_keys': (<Notes />),
    'submit': (<Send />),
    'click': (<AdsClick />),
    'try_function': (<MiscellaneousServices />),
    'print': (<Message />),
    'close': (<WebAssetOff />),
    'stop': (<StopCircle />),
    'error': (<Error />),
    'send_logs': (<PlaylistAdd />)
}

const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 204) {
        toast.success('Deletado com sucesso')
        setState({ deleteRow: false })
        getData()
        return
    }
    console.error('Falha ao deletar')

}

const columns = (state, setState, permissions) => {
    return [
        { field: 'name', headerName: 'Nome', flex: 1, filterType: 'string' },
        { field: 'created_at', headerName: 'Data de execução', flex: 1, filterType: 'daterange',  
            valueGetter: ({ value }) => value ? dayjs(value).format('DD/MM/YYYY HH:mm') : ''
        },
        { field: 'state', headerName: 'Status de Execução', flex: 1, filterType: 'string', valueGetter: ({value}) => state.status[value] },
        {
            field: 'actions', headerName: 'Ações', filterable: false,
            renderCell: (props) => {
                return (
                    <ResponsiveActionBox >
                        {permissions.view_functionlogs && <Tooltip title='Editar log'>
                            <IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton>
                        </Tooltip>}
                        {permissions.delete_functionlogs && <Tooltip title='Excluir log'>
                            <IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton>
                        </Tooltip>}
                    </ResponsiveActionBox>
                )
            }
        }
    ]
}

export const loadData = async (setState, permission, setLoader) => {
    if (!permission) {
        toast.error('Você não tem permissão para ver os logs de execução')
        return
    }
    const requests = [
        api.get('/permissions/'),
        api.get(url + 'status/')
    ]
    const [permissions, status] = await Promise.all(requests)
    const result = {}
    if (permissions.status === 200)
        result.permissions = permissions.data.results
    if (status.status === 200)
        result.status = status.data
    setState({ ...result })
}

const FunctionLogs = () => {

    const { setLoader } = useContext(externalComponent)

    const user = getSession()

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        permissions: [],
        editRow: null,
        deleteRow: null,
        status: {}
    })

    useEffect(() => {
        loadData(setState, user.permissions.view_functionlogs, setLoader)
    }, [setLoader, user.permissions.view_functionlogs])

    const [table, reloadTable] = TableHook()

    const reloadData = () => {
        loadData(setState, user.permissions.view_functionlogs, setLoader)
        reloadTable()
    }

    return (
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o log ${state.deleteRow.name}?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }
            {state.editRow &&
                <EditFunctionLogsModal
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                    permissions={state.permissions}
                />
            }
            <Box className='information-table'>
                <Box className='user-table'>
                    <Table
                        rows={state.rows}
                        columns={useMemo(()=> columns(state, setState, user.permissions), [user.permissions])}
                        pagination
                        density='compact'
                        slots={{
                            returnComponent: ()=> window.backtobase(),
                            // addComponent: user.permissions.add_executionlogs ? () => setState({ editRow: {} }) : null,
                            filterComponent: true,
                            columnComponent: true
                        }}
                        toolbar
                        getURL={url}
                        updateRows={(rows) => setState({'rows': rows})}
                        innerRef={table}
                        mobile={true}
                        mobileProps={
                            {
                                title:['name']
                            }
                        }
                    />
                </Box>
            </Box>
        </>
    )
}

export default FunctionLogs